import { createSelector } from '@ngrx/store';
import { CoreState, getCoreState } from '../../../store/reducers';
import { UserCustomizationsState } from '../reducers/user-customizations.reducer';

const getUserCustomizationsState = createSelector(
  getCoreState,
  (state: CoreState) => state.userCustomizations,
);

const getUserCustomizations = ({
  userCustomizations,
}: UserCustomizationsState) => userCustomizations;

const getUserCustomizationsLoading = ({ loading }: UserCustomizationsState) =>
  loading;

const getUserCustomizationsError = ({ error }: UserCustomizationsState) =>
  error;

export const getCoreStateGetUserCustomizations = createSelector(
  getUserCustomizationsState,
  getUserCustomizations,
);

export const getCoreStateGetUserCustomizationsLoading = createSelector(
  getUserCustomizationsState,
  getUserCustomizationsLoading,
);

export const getCoreStateGetUserCustomizationsError = createSelector(
  getUserCustomizationsState,
  getUserCustomizationsError,
);
